/**
 * DayWiseTable — 6-column compact table (CR-0015 / Δ-14, polished CR-0015a / Δ-14a).
 *
 * Δ-14a changes:
 *  - All cells `text-center` (was left-aligned).
 *  - Vertical column dividers via `border-r` on every cell except the last.
 *  - Row hover state `bg-#FAFAFA` for scannability.
 *  - Date column stays sticky on mobile horizontal scroll.
 *
 * Cell value colours (locked C-27):
 *  Avg green, Max red, Min purple — same hues as Summary cards.
 */
import { fmtTime, displayDate } from "@/utils/fmtTime";

const HEADERS = [
  { key: "date", label: "Date", sticky: true },
  { key: "rooms", label: "Rooms" },
  { key: "sessions", label: "Sessions" },
  { key: "avg_seconds", label: "Avg Time", color: "#16A34A" },
  { key: "max_seconds", label: "Max Time", color: "#DC2626" },
  { key: "min_seconds", label: "Min Time", color: "#7C3AED" },
];

export default function DayWiseTable({ days }) {
  if (!days || days.length === 0) return null;
  return (
    <div
      data-testid="day-wise-table-wrap"
      className="mx-4 mt-3 bg-white rounded-md shadow-sm border overflow-x-auto"
      style={{ borderColor: "#E5E7EB" }}
    >
      <table data-testid="day-wise-table" className="w-full text-sm border-collapse">
        <thead>
          <tr style={{ backgroundColor: "#F3F4F6" }}>
            {HEADERS.map((h, i) => (
              <th
                key={h.key}
                className={`text-center py-3 px-4 font-semibold ${
                  h.sticky ? "sticky left-0" : ""
                } ${i < HEADERS.length - 1 ? "border-r" : ""}`}
                style={{
                  color: "#111827",
                  backgroundColor: "#F3F4F6",
                  borderColor: "#E5E7EB",
                }}
              >
                {h.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {days.map((d, i) => (
            <tr
              key={d.date}
              data-testid={`day-row-${d.date}`}
              className="hover:bg-gray-50 transition-colors"
              style={{
                borderTop: i === 0 ? "none" : "1px solid #E5E7EB",
              }}
            >
              <td
                className="text-center py-3 px-4 sticky left-0 bg-white border-r"
                style={{ color: "#111827", borderColor: "#E5E7EB" }}
              >
                {displayDate(d.date)}
              </td>
              <td
                className="text-center py-3 px-4 border-r"
                style={{ color: "#111827", borderColor: "#E5E7EB" }}
              >
                {d.rooms}
              </td>
              <td
                className="text-center py-3 px-4 border-r"
                style={{ color: "#111827", borderColor: "#E5E7EB" }}
              >
                {d.sessions}
              </td>
              <td
                className="text-center py-3 px-4 font-bold border-r"
                style={{ color: "#16A34A", borderColor: "#E5E7EB" }}
              >
                {fmtTime(d.avg_seconds)}
              </td>
              <td
                className="text-center py-3 px-4 font-bold border-r"
                style={{ color: "#DC2626", borderColor: "#E5E7EB" }}
              >
                {fmtTime(d.max_seconds)}
              </td>
              <td
                className="text-center py-3 px-4 font-bold"
                style={{ color: "#7C3AED" }}
              >
                {fmtTime(d.min_seconds)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
